var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/24/enabled") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.55183315,7.22712473 C3.34933907,7.02685586 3.0210313,7.02685586 2.81853722,7.22712473 C2.61604315,7.4273936 2.61604315,7.75209358 2.81853722,7.95236245 L5.41112982,10.516465 C5.61362389,10.7167339 5.94193166,10.7167339 6.14442574,10.516465 L11.8481294,4.87543937 C12.0506235,4.67517051 12.0506235,4.35047052 11.8481294,4.15020165 C11.6456354,3.94993278 11.3173276,3.94993278 11.1148335,4.15020165 L5.77777778,9.42860843 L3.55183315,7.22712473 Z M7.33333333,6.66133815e-16 C3.28324517,6.66133815e-16 6.66133815e-16,3.28324517 6.66133815e-16,7.33333333 C6.66133815e-16,11.3834215 3.28324517,14.6666667 7.33333333,14.6666667 C11.3834215,14.6666667 14.6666667,11.3834215 14.6666667,7.33333333 C14.6666667,3.28324517 11.3834215,6.66133815e-16 7.33333333,6.66133815e-16 Z M7.33333333,1.33333333 C10.6470418,1.33333333 13.3333333,4.01962483 13.3333333,7.33333333 C13.3333333,10.6470418 10.6470418,13.3333333 7.33333333,13.3333333 C4.01962483,13.3333333 1.33333333,10.6470418 1.33333333,7.33333333 C1.33333333,4.01962483 4.01962483,1.33333333 7.33333333,1.33333333 Z",
    id: "enabled-path"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/24/enabled",
    transform: "translate(0.666667, 0.666667)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "enabled-mask",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#enabled-path"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#enabled-path"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon/Color/black",
    mask: "url(#enabled-mask)",
    fill: "#006008"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.666667, -0.666667)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 16,
    height: 16
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnabled);
export default __webpack_public_path__ + "static/media/enabled.7450e3bc9931668df39ee57814965f2d.svg";
export { ForwardRef as ReactComponent };